import Paginator from "./paginator.container";


export default Paginator;